<template>
	<b-modal
		v-model="show"
		:header="false"
		:footer="false"
		class="fade backdrop"
		@hide="close"
	>
		<div slot="default">
			<div class="iadsa-modal-header">
				<b-btn class="close btn btn-head-modal" @click="show=false">
					<i class="material-icons">close</i>
				</b-btn>
			</div>
			<div class="iadsa-modal-body">
				<h5>My profile</h5>
				<h2>Update contact details</h2>
				<div class="form-group">
					<div class="row">
						<div class="col-xs-12">
							<label
								v-if="$v.newEmailAddress.$error && !$v.newEmailAddress.required"
								class="label error pull-right"
							>Required</label>
							<label>Email address</label>
							<input
								v-model="newEmailAddress"
								type="email"
								:class="{ 'error': $v.newEmailAddress.$error }"
								class="form-control"
								style="height:40.25px;"
								placeholder="Email address"
								@keyup.enter="update(details.id)"
							/>
						</div>
					</div>
					<div style="margin-top:30px">
						<b-btn type="danger" @click="show=false">
							Close
						</b-btn>
						<b-btn type="primary" @click="update">
							<strong>Save</strong>
						</b-btn>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<style lang="less" scoped>
	.btn {
		margin-right: 5px;
	}
	.error {
		border-color: red;
		color: red;
	}
</style>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
	props: {
		showContactDetailsModal: {
			type: Boolean,
			required: true
		},
		details: {
			type: Object,
			default: () => ({})
		}
	},
	validations: {
		newEmailAddress: { required, minLength: minLength(1), email },
	},
	data() {
		return {
			show: false,
			newEmailAddress: null
		};
	},
	watch: {
		showContactDetailsModal() {
			this.show = this.showContactDetailsModal;
		}
	},
	methods: {
		close() {
			this.$emit('closeContactDetailsModal');
		},
		update() {
			if (this.$v.$invalid) {
				this.$v.$touch();
			} else {
				this.$emit('updateContactDetails', {
					email_address: this.newEmailAddress
				});
				this.newEmailAddress = null;
			}
		}
	}
};
</script>
